let data;
export default data = [
    {
        img:"https://www.jefit.com/images/exercises/800_600/4268.jpg",
        link:"Barbell Reverse Grip Incline Bench Press",
        types:"Chest, Shoulders, Triceps"
    },
    {
        img:"https://www.jefit.com/images/exercises/800_600/500.jpg",
        link:"Barbell Palms Up Wrist Curl",
        types:"Forearm, Shoulders, Triceps"
    },
    {
        img:"https://www.jefit.com/images/exercises/800_600/4412.jpg",
        link:"Dumbbell One-Arm Front Raise",
        types:"Shoulders, Shoulders, Triceps"
    },
    {
        img:"https://www.jefit.com/images/exercises/800_600/1276.jpg",
        link:"Step Machine",
        types:"Cardio, Shoulders, Triceps"
    },
    {
        img:"https://www.jefit.com/images/exercises/800_600/2044.jpg",
        link:"Downward Facing Puppy Dog",
        types:"Abs, Back, Shoulders"
    },
    {
        img:"https://www.jefit.com/images/exercises/800_600/4096.jpg",
        link:"Dumbbell One-Arm Seated Hammer Curl",
        types:"Biceps, Forearm, Shoulders"
    },
    {
        img:"https://www.jefit.com/images/exercises/800_600/220.jpg",
        link:"Barbell Supine Triceps Extension",
        types:"Triceps, Forearm, Shoulders"
    },
    {
        img:"https://www.jefit.com/images/exercises/800_600/4148.jpg",
        link:"Barbell Incline Bench Row",
        types:"Back, Biceps, Shoulders"
    },
    {
        img:"https://www.jefit.com/images/exercises/800_600/4088.jpg",
        link:"Dumbbell One-Arm Prone Curl",
        types:"Biceps, Biceps, Shoulders"
    },
    {
        img:"https://www.jefit.com/images/exercises/800_600/2584.jpg",
        link:"Dumbbell Alternating Lateral Raise on Stability Ball",
        types:" Shoulders, Abs, Shoulders"
    },
    {
        img:"https://www.jefit.com/images/exercises/800_600/5340.jpg",
        link:"Cable One-Arm Concentration Curl",
        types:" Biceps, Abs, Shoulders"
    },
    {
        img:"https://www.jefit.com/images/exercises/800_600/2760.jpg",
        link:"Hanging Knee Raise",
        types:"Abs, Abs, Shoulders"
    },
    {
        img:"https://www.jefit.com/images/exercises/800_600/128.jpg",
        link:"Dumbbell Lateral Raise",
        types:" Shoulders, Abs, Shoulders"
    },
    {
        img:"https://www.jefit.com/images/exercises/800_600/1028.jpg",
        link:"Cable Rope Hammer Curl",
        types:"Biceps, Forearm, Shoulders"
    },
    {
        img:"https://www.jefit.com/images/exercises/800_600/1868.jpg",
        link:"Barbell Deep Squat",
        types:"Upper Legs, Glutes, Back"
    },
    {
        img:"https://www.jefit.com/images/exercises/800_600/1156.jpg",
        link:"Ankle Circles",
        types:"Lower Legs, Glutes, Back"
    },
    {
        img:"https://www.jefit.com/images/exercises/800_600/984.jpg",
        link:"Cable Standing One-Arm Tricep Extension",
        types:"Triceps, Glutes, Back"
    },
    {
        img:"https://www.jefit.com/images/exercises/800_600/904.jpg",
        link:"Cable Lying Tricep Extension",
        types:" Triceps, Triceps, Lower Legs"
    },

]